import Vue from 'vue'
Vue.use({
  install() {
    Vue.prototype.$transform = {
      appendUnit(unit = '', value) {
        return `${value} ${unit}`
      },
    }
  },
})
